module.exports = __webpack_public_path__ + "static/media/Services.07461ae4.svg";